module.exports = __webpack_public_path__ + "media/images/Tent and Truck-ad58d33f.jpg";